module.exports = __webpack_public_path__ + "img/search.058f5129.png";